// src/pages/admin/DashboardPage.js
import React, { useState } from 'react';

// ייבוא הדפים
import OwnersPage from './OwnersPage';
import BusinessDetailsPage from './BusinessDetailsPage';
import SubjectsPage from './SubjectsPage';
import ArticlesPage from './ArticlesPage';
import ReviewsPage from './ReviewsPage';
import LeadsPage from './LeadsPage';


import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import { 
  Users, 
  Briefcase, 
  FileText, 
  MessageSquare, 
  PhoneCall, 
  LogOut, 
  Menu, 
  X 
} from 'lucide-react';
import { logoutUser } from '../../services/auth';

const DashboardPage = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const menuItems = [
    { title: 'בעלי המשרד', icon: <Users />, path: 'owners', component: OwnersPage },
    { title: 'פרטי העסק', icon: <Briefcase />, path: 'business', component: BusinessDetailsPage },
    { title: 'תחומי התמחות', icon: <FileText />, path: 'subjects', component: SubjectsPage },
     { title: 'מאמרים', icon: <FileText />, path: 'articles', component: ArticlesPage },
    { title: 'המלצות', icon: <MessageSquare />, path: 'reviews', component: ReviewsPage },
    { title: 'לידים', icon: <PhoneCall />, path: 'leads', component: LeadsPage }
  ];

  const handleLogout = async () => {
    try {
      const result = await logoutUser();
      if (result.success) {
        navigate('/login');
      }
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const SideMenu = () => (
    <div className={`
      fixed inset-y-0 right-0 w-64 bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out
      ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}
      md:relative md:translate-x-0 md:block
    `}>
      <div className="p-4 flex-1">
        <div className="flex justify-between items-center mb-8 md:hidden">
          <h2 className="text-xl font-bold text-gray-800">ממשק ניהול</h2>
          <button onClick={toggleMobileMenu} className="text-gray-600">
            <X className="w-6 h-6" />
          </button>
        </div>
        <h2 className="hidden md:block text-xl font-bold text-gray-800 mb-8">ממשק ניהול</h2>
        <nav className="space-y-2">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => setIsMobileMenuOpen(false)}
              className="flex items-center space-x-3 space-x-reverse p-3 rounded-lg text-gray-600 hover:bg-blue-50 hover:text-blue-600 transition-colors"
            >
              {item.icon}
              <span>{item.title}</span>
            </Link>
          ))}
        </nav>
      </div>
      
      {/* כפתור התנתקות */}
      <div className="p-4 border-t">
        <button
          onClick={handleLogout}
          className="flex items-center justify-center w-full p-3 space-x-2 space-x-reverse rounded-lg text-red-600 hover:bg-red-50 transition-colors"
        >
          <LogOut className="w-5 h-5" />
          <span>התנתקות</span>
        </button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="flex relative">
        {/* Mobile Menu Toggle Button */}
        <button 
          onClick={toggleMobileMenu}
          className="fixed top-4 right-4 z-40 md:hidden bg-white p-2 rounded-lg shadow-md"
        >
          <Menu className="w-6 h-6 text-gray-600" />
        </button>

        {/* Sidebar for Desktop and Mobile */}
        <SideMenu />

        {/* Main Content */}
        <div className="flex-1 p-8 md:mr-0">
          <Routes>
            {menuItems.map((item) => (
              <Route
                key={item.path}
                path={item.path}
                element={<item.component />}
              />
            ))}
          </Routes>
        </div>

        {/* Overlay for mobile menu */}
        {isMobileMenuOpen && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
            onClick={() => setIsMobileMenuOpen(false)}
          />
        )}
      </div>
    </div>
  );
};

export default DashboardPage;